<template>
  <TemplatePopup :showMessage="showMessage" :fullScreen="fullScreen" :geometry="entity.geometry">
    <div slot="header" class="header-container">
      <div class="header-title">
        <strong>Cliente</strong>
        <CreationDate :date="entity.created" />
      </div>
    </div>
    <div slot="body">
      <tabs v-model="tabIndex">
        <tab title="Dados" :selected="true">
          <b-form-group label="Tipo de Cliente:">
            <b-form-select id="selectClientType" v-model="entity.clientType" :options="options"
              :class="{ 'is-invalid': missingClientType }" size="sm"></b-form-select>
          </b-form-group>

          <b-form-group label="Nome:">
            <b-form-input id="inputName" v-model="entity.name" :class="{ 'is-invalid': missingName }" maxlength="50"
              size="sm"></b-form-input>
          </b-form-group>

          <b-form-group label="Identificação extra:">
            <b-form-input id="inputExtra" v-model="entity.identifier" maxlength="50" size="sm"></b-form-input>
          </b-form-group>

          <div class="row">
            <b-form-group label="CPF/CNPJ:" for="cpfCnpj" class="col-6">
              <b-form-input id="inputCpfCnpj" v-model="entity.cpfCnpj" v-mask="['###.###.###-##', '##.###.###/####-##']"
                size="sm"></b-form-input>
            </b-form-group>

            <b-form-group label="Telefone:" class="col-6">
              <b-form-input v-model="entity.phone" @input="formatTelefone" maxlength="15" size="sm"
                id="inputPhone"></b-form-input>
            </b-form-group>
          </div>

          <b-form-group label="Endereço:">
            <b-form-input id="inputAddress" v-model="entity.address" maxlength="255"
              :class="{ 'is-invalid': missingAddress }" size="sm"></b-form-input>
          </b-form-group>

          <b-form-group label="Endereços sugeridos:" v-if="isNew && entity.category != 'I'">
            <b-form-select id="addressList" v-model="entity.address" size="sm">
              <b-form-select-option v-for="(address, index) in addressList" :value="address.formatted_address"
                :key="index">
                {{ address.formatted_address }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Pasta:">
            <b-form-select id="selectFolder" v-model="entity.folderId" size="sm"
              :class="{ 'is-invalid': missingFolder }">
              <b-form-select-option v-for="entityList in folderList" :value="entityList.id" :key="entityList.id">
                {{ entityList.name }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Bloco:" v-if="entity.category === 'I'">
            <b-form-input id="inputBlock" v-model="entity.block" maxlength="50" size="sm"></b-form-input>
          </b-form-group>

          <b-form-group label="Andar:" v-if="entity.category === 'I'">
            <b-form-input type="number" id="inputFloor" v-model="entity.floor" size="sm"></b-form-input>
          </b-form-group>

          <b-form-group label="SN ONT:">
            <b-form-input id="inputSnOnt" v-model="entity.sn" maxlength="255" size="sm"></b-form-input>
          </b-form-group>

          <div class="row mr-n14" v-if="!isNew">
            <div class="col-md-6 col-sm-12 mb-1">
              <div class="form-group">
                <label>Status</label>
                <div class>
                  <b-button id="btnWaiting" title="Aguardando" @click.prevent="waiting()" variant="outline-light"
                    :disabled="isNew">
                    <img class="img-btn" src="../../../assets/img/svg/blue_outline.svg" />
                  </b-button>

                  <b-button id="btnMigration" title="Migração" @click.prevent="migration()" variant="outline-light"
                    :disabled="isNew">
                    <img class="img-btn" src="../../../assets/img/svg/yellow_outline.svg" />
                  </b-button>

                  <b-button id="btnEffective" title="Ativo" @click.prevent="effective()" variant="outline-light"
                    :disabled="isNew">
                    <img class="img-btn" src="../../../assets/img/svg/green_outline.svg" />
                  </b-button>

                  <b-button id="btnBlocked" title="Bloqueado" @click.prevent="blocked()" variant="outline-light"
                    :disabled="isNew">
                    <img class="img-btn" src="../../../assets/img/svg/user_outline.svg" />
                  </b-button>

                  <b-button id="btnCanceled" title="Cancelado" @click.prevent="canceled()" variant="outline-light"
                    :disabled="isNew">
                    <img class="img-btn" src="../../../assets/img/svg/silver_outline.svg" />
                  </b-button>

                  <b-button id="btnGivingup" title="Desistência" @click.prevent="givingup()" variant="outline-light"
                    :disabled="isNew">
                    <img class="img-btn" src="../../../assets/img/svg/white_outline.svg" />
                  </b-button>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12 mt-3">
              <CardSignal id="statusSignal" text="Sinal OLT" :value="entity.signal" :status="entity.statusSignal"
                :date="entity.updated" @click="tabIndex = 1" class="c-pointer" />
            </div>
          </div>
        </tab>
        <!-- <tab id="tabOLT" title="OLT" v-if="!isNew" :permission="['OLT', 'VI']"> -->
        <!-- <OltData :equipmentId="entity.id" :updateMap="updateMapBindSn" /> -->
        <!-- </tab> -->
        <tab id="ConnectedEquipment" title="Equipamentos Conectados" :permission="['CTO', 'VI']" v-if="!isNew">
          <ConnectedEquipment :equipmentId="entity.id" :updateAction="getOne" :showAttendance="true"
            equipmentType="S" />
        </tab>
        <tab id="tabFiber" title="Rota" v-if="!isNew">
          <div class="text-center pb-3" v-if="cables.length === 0">
            <div class="empty-state">
              <i class="icon icon-cable icon-3x"></i>
              <h5>Não existem cabos disponíveis</h5>
            </div>
          </div>

          <div v-for="(cable, index) in cables" :key="cable.id" class="cable-panel">
            <div class="cable-header" @click="toggleCable(index)" :class="{ 'active': activeCableIndex === index }">
              <span>{{ cable.name }}</span>
              <i class="fa" :class="activeCableIndex === index ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
            </div>
            <div v-if="activeCableIndex === index" class="cable-content">
              <div>
                <CableEdges :cableId="cable.id" :folderId="folderId" :cable="cable.geometry" id="cableEdges" />
              </div>
              <div>
                <Fiber :equipmentId="cable.id" :fullScreen="fullScreen" :folderId="folderId"
                  :category="cable.category" :hiddenDamagedFiber="true" />
              </div>
            </div>
          </div>
        </tab>
      </tabs>
    </div>
    <div slot="button">
      <div class="text-center">
        <b-button-group>
          <b-button id="btnOtdr" v-has-permission.permission="['OTR', 'VI']" @click.prevent="OTDR()" variant="muted"
            :disabled="isNew">
            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">OTDR</p>
          </b-button>
          <b-button id="btnViability" v-has-permission.permission="['AVA', 'VI']" @click.prevent="viability()"
            variant="muted" :disabled="isNew">
            <i class="fa fa-line-chart fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Viabilidade</p>
          </b-button>

          <b-button id="btnComments" @click.prevent="comment()" v-has-permission.permission="['COM', 'VI']"
            variant="muted" :disabled="isNew">
            <i class="fa fa-comments fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Comentários</p>
          </b-button>

          <b-button id="btnImage" @click.prevent="image()" v-has-permission.permission="['IMG', 'VI']" variant="muted"
            :disabled="isNew">
            <i class="fa fa-picture-o fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Imagem</p>
          </b-button>

          <b-button id="btnDelete" @click.prevent="remove()" v-has-permission.permission="['CLI', 'EX']" variant="muted"
            :disabled="isNew">
            <i class="fa fa-times-circle fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Excluir</p>
          </b-button>

          <b-button id="btnSave" @click.prevent="saveLocal()" v-has-permission.permission="['CLI', 'AL']"
            variant="muted" :disabled="saveDisabled">
            <i class="fa fa-floppy-o fa-lg"></i>
            <p class="button-text mb-0">Salvar</p>
          </b-button>
        </b-button-group>
      </div>
    </div>
  </TemplatePopup>
</template>

<script>
import TemplatePopup from "../../../template/TemplatePopup";
import { sitePath, cablePath, folderSimplePath } from "../../../router/ApiPaths";
import PopupBase from "./PopupBase";
import { updateMap } from "../../../components/MessageBus";
import { openSubPopup } from "./index";
import CardSignal from "../../../components/extra/CardSignal";
import Tabs from "./Tabs/Tabs";
import Tab from "./Tabs/Tab";
import Fiber from "./Tabs/Fiber";
import { mask } from "vue-the-mask";
import CreationDate from "./CreationDate"
import ConnectedEquipment from "./Tabs/ConnectedEquipment.vue";
import CableEdges from "./CableEdges";

export default {
  name: "ClientMap",
  extends: PopupBase,
  components: {
    TemplatePopup,
    CardSignal,
    Tab,
    Tabs,
    CreationDate,
    ConnectedEquipment,
    Fiber,
    CableEdges
  },
  directives: { mask },
  data() {
    return {
      folderList: [],
      tabIndex: 0,
      options: [
        { value: "R", text: "Residencial" },
        { value: "C", text: "Comercial" },
        { value: "E", text: "Empresarial" },
        { value: "I", text: "Industrial" },
      ],
      activeCableIndex: 0,
      cables: [],
    };
  },
  beforeMount() {
    this.entity = {
      id: null,
      folderId: null,
      category: this.extra && this.extra.category ? this.extra.category : "E",
      address:
        this.extra && this.extra.address
          ? this.extra.address
          : this.entity.address,
      equipmentExternalId:
        this.extra && this.extra.equipmentExternalId
          ? this.extra.equipmentExternalId
          : undefined,
      positionDiagram:
        this.extra && this.extra.positionDiagram
          ? this.extra.positionDiagram
          : undefined,
    };
  },
  mounted: function () {
    let path = sitePath(this.folderId);

    if (this.extra && this.extra.category === "I") this.init(path);
    else this.init(path, true);

    this.getAllDirect(folderSimplePath).then((data) => {
      this.folderList = data;
    });
  },
  computed: {
    missingName: function () {
      return !this.entity.name;
    },
    missingAddress: function () {
      return !this.entity.address;
    },
    missingFolder: function () {
      return !this.entity.folderId;
    },
    missingClientType: function () {
      return !this.entity.clientType;
    },
    saveDisabled: function () {
      return this.missingName || this.missingAddress || this.missingClientType || this.missingFolder || !this.isDirty;
    },
    showMessage: function () {
      return this.saveDisabled && this.tabIndex !== 2
    }
  },
  methods: {
    updateMapBindSn(entity) {
      this.sendMapActionMap(updateMap, entity);
    },
    changeState(complement) {
      this.putDirect(this.path + complement).then((data) => {
        this.sendMapActionMap(updateMap, data, true);
      });
    },
    getCables() {
      if (this.entity.id == null) return;

      let path = cablePath(this.folderId);
      this.getAllDirect(path + `/equipment/${this.entity.id}`).then((data) => {
        this.cables = data.map(cable => ({...cable, damaged: false}));
        this.activeCableIndex = this.cables.length === 1 ? 0 : null;
        console.log(data)
      });

    },
    toggleCable(index) {
      if (this.activeCableIndex === index) {
        this.activeCableIndex = null;
      } else {
        this.activeCableIndex = index;
      }
    },
    waiting() {
      this.changeState("/waiting");
    },
    migration() {
      this.changeState("/migration");
    },
    effective() {
      this.changeState("/effective");
    },
    blocked() {
      this.changeState("/blocked");
    },
    canceled() {
      this.changeState("/canceled");
    },
    givingup() {
      this.changeState("/givingup");
    },
    viability() {
      openSubPopup(6, null, null, this.entity);
    },
    formatTelefone() {
      let value = this.entity.phone.replace(/\D/g, "");
      const digitCount = value.length;

      if (digitCount > 11) {
        value = value.slice(0, 11);
      }

      if (digitCount === 10) {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})$/, "($1) $2-$3");
      } else if (digitCount === 11) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})$/, "($1) $2-$3");
      } else {
        value = value.replace(/^(\d{2})(\d{4,5})(\d{0,4})$/, "($1) $2-$3");
      }

      this.entity.phone = value;
    },
    saveLocal() {
      if (!this.folderId)
        this.path = sitePath(this.entity.folderId);
      this.save();
    },
  },
  watch: {
    phone(value) {
      if (value) {
        const digitCount = value.replace(/\D/g, "").length;
        this.telefoneMask =
          digitCount === 9 ? "(##) #####-####" : "(##) ####-####";
      }
    },
    tabIndex(newIndex) {
      if (newIndex === 2 && this.cables.length === 0) {
        this.getCables();
      }
    }
  },
};
</script>

<style lang="sass" scoped>
.button_status
  height: 44px
  width: 45px
  margin-bottom: 4px

.form-control
  height: 30px

.empty-state
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  padding: 1.5rem
  color: #6c757d

.cable-panel
  border: 1px solid #e0e0e0
  margin-bottom: 8px
  border-radius: 4px

.cable-header
  padding: 12px 16px
  background-color: #f8f9fa
  cursor: pointer
  display: flex
  justify-content: space-between
  align-items: center
  transition: background-color 0.2s ease
  border-radius: 4px 4px 0 0
  
  &:hover
    background-color: #f9fafc
    
  &.active
    background-color: #f9fafc

  span
    font-weight: 500
    
  i
    transition: transform 0.2s ease

.cable-content
  padding: 16px
  border-top: 1px solid #e0e0e0
  background-color: white
</style>
